import script from "./IncidentItemComponentAux.vue?vue&type=script&setup=true&lang=ts"
export * from "./IncidentItemComponentAux.vue?vue&type=script&setup=true&lang=ts"

import "./IncidentItemComponentAux.vue?vue&type=style&index=0&id=057f6d45&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-057f6d45"]])

export default __exports__